import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-brand-light text-gray-700 pt-16 pb-8 border-t-4 border-brand-red">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="https://assets.auxodev.dk/assets/518c2382-ce7b-462f-b5ef-9cfd635d4d85/logo-1-7541a179.png"
                alt="Sloth’s Maskinstation"
                className="h-28 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-gray-600 leading-relaxed">
              Sloth’s Maskinstation tilbyder professionel landbrugsmaskinstation, entreprenør- og anlægsarbejde, maskinudlejning samt salg af sand, sten og grus i Bjerringbro og omegn.
            </p>
            <div className="flex gap-4 pt-2">
              <a
                href="https://www.facebook.com/Slothsmaskinstationen"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-black/5 text-gray-600 hover:bg-brand-red hover:text-white transition-all duration-200"
                aria-label="Følg os på Facebook"
              >
                <i className="fa-brands fa-facebook-f text-lg" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-brand-dark mb-5 font-display uppercase tracking-wider border-l-2 border-brand-red pl-3">
              Ydelser
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/landbrugsmaskinstation" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Landbrugsmaskinstation
                </Link>
              </li>
              <li>
                <Link to="/entreprenoer-og-anlaeg" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Entreprenør & Anlæg
                </Link>
              </li>
              <li>
                <Link to="/maskinudlejning-salg" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Maskinudlejning / Salg
                </Link>
              </li>
              <li>
                <Link to="/sand-sten-grus" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Salg af sand, sten & grus
                </Link>
              </li>
            </ul>
          </div>

          {/* Materialer */}
          <div>
            <h4 className="text-lg font-bold text-brand-dark mb-5 font-display uppercase tracking-wider border-l-2 border-brand-red pl-3">
              Materialer
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/sand-sten-grus/sand-flis" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Sand & Flis
                </Link>
              </li>
              <li>
                <Link to="/sand-sten-grus/grus" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Grus
                </Link>
              </li>
              <li>
                <Link to="/sand-sten-grus/stenmel" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Stenmel
                </Link>
              </li>
              <li>
                <Link to="/sand-sten-grus/stabilgrus" className="hover:text-brand-red transition-colors flex items-center gap-2">
                  <i className="fa-regular fa-chevron-right text-[10px] text-brand-red" />
                  Stabilgrus
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-lg font-bold text-brand-dark mb-5 font-display uppercase tracking-wider border-l-2 border-brand-red pl-3">
              Kontakt os
            </h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-brand-red mt-1" />
                <span className="leading-relaxed">
                  Gullev Byvej 24, Gullev<br />
                  8850 Bjerringbro
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-brand-red" />
                <a href="tel:004540420286" className="hover:text-brand-red transition-colors whitespace-nowrap">
                  +45 4042 0286
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-brand-red" />
                <a href="mailto:slothsmaskinstation@gmail.com" className="hover:text-brand-red transition-colors break-all">
                  slothsmaskinstation@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-500 text-xs pt-1">
                <i className="fa-regular fa-id-card text-brand-red" />
                <span>CVR: 37972177</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 border-t border-black/10 pt-8 text-center text-xs text-gray-500 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {currentYear} Sloth’s Maskinstation. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/om-os-galleri/etableringsstoette"
              className="hover:text-brand-red transition-colors inline-flex items-center gap-1.5 underline decoration-gray-300 hover:decoration-brand-red"
            >
              <i className="fa-solid fa-flag-checkered text-brand-red text-[11px]" />
              <span>EU Etableringsstøtte</span>
            </Link>
            <span className="text-gray-300 hidden sm:inline">•</span>
            <p className="flex items-center gap-1.5">
              <span>Udviklet af</span>
              <a href="https://auxo.dk" target="_blank" rel="noopener noreferrer" className="hover:text-brand-dark hover:underline transition-colors font-bold tracking-wider">
                AUXO
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
